import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import React from "react"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getCardBrandIcon(brand: string): React.ReactNode {
  switch (brand.toLowerCase()) {
    case "visa":
      return (
        <svg
          className="w-full h-full"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
            fill="#1434CB"
          />
          <path d="M21.6 28.2001L23.2 19.8001H25.6L24 28.2001H21.6Z" fill="white" />
          <path
            d="M32.8 20.0001C32.4 19.8001 31.6 19.6001 30.8 19.6001C28.8 19.6001 27.2 20.8001 27.2 22.4001C27.2 23.6001 28.4 24.2001 29.2 24.6001C30 25.0001 30.4 25.2001 30.4 25.6001C30.4 26.2001 29.6 26.4001 28.8 26.4001C28 26.4001 27.2 26.2001 26.4 25.8001L26 25.6001L25.6 27.8001C26 28.0001 27.2 28.4001 28.4 28.4001C30.8 28.4001 32 27.2001 32 25.6001C32 24.6001 31.2 24.0001 30 23.4001C29.2 23.0001 28.8 22.8001 28.8 22.4001C28.8 22.0001 29.2 21.6001 30.4 21.6001C31.2 21.6001 32 21.8001 32.4 22.0001L32.8 22.2001L33.2 20.2001C32.8 20.0001 32.8 20.0001 32.8 20.0001Z"
            fill="white"
          />
          <path
            d="M37.6 19.8001H35.6C35.2 19.8001 34.8 20.0001 34.4 20.4001L30.8 28.2001H33.2C33.2 28.2001 33.6 27.0001 33.6 26.8001C34 26.8001 36.4 26.8001 36.8 26.8001C36.8 27.0001 37.2 28.2001 37.2 28.2001H39.2L37.6 19.8001ZM34.4 24.8001C34.8 24.0001 35.6 22.0001 35.6 22.0001C35.6 22.0001 35.6 22.4001 36 23.2001L36.4 24.8001H34.4Z"
            fill="white"
          />
          <path
            d="M18.8 19.8001L16.4 25.6001L16 24.4001C15.6 23.2001 14 21.8001 12.4 21.2001L14.8 28.2001H17.2L21.2 19.8001H18.8Z"
            fill="white"
          />
          <path
            d="M14 19.8001H10L10 20.0001C13.2 20.8001 15.2 22.4001 16 24.4001L15.2 20.4001C15.2 20.0001 14.8 19.8001 14 19.8001Z"
            fill="#F7B600"
          />
        </svg>
      )
    case "mastercard":
      return (
        <svg
          className="w-full h-full"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
            fill="#252525"
          />
          <path
            d="M24 32C20.4 32 17.2 30.2 15.2 27.6C13.2 25 13.2 21.8 15.2 19.2C17.2 16.6 20.4 14.8 24 14.8C27.6 14.8 30.8 16.6 32.8 19.2C34.8 21.8 34.8 25 32.8 27.6C30.8 30.2 27.6 32 24 32Z"
            fill="#EB001B"
          />
          <path
            d="M24 32C20.4 32 17.2 30.2 15.2 27.6C13.2 25 13.2 21.8 15.2 19.2C17.2 16.6 20.4 14.8 24 14.8"
            fill="#F79E1B"
          />
        </svg>
      )
    case "amex":
      return (
        <svg
          className="w-full h-full"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
            fill="#006FCF"
          />
          <path
            d="M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z"
            fill="#F7B600"
          />
        </svg>
      )
    default:
      return (
        <svg
          className="w-full h-full"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
            fill="#E6E6E6"
          />
          <path
            d="M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z"
            fill="#10212b"
          />
        </svg>
      )
  }
}
